import { render } from "./UploadPhotosCard.vue?vue&type=template&id=10cfca27&lang=true"
import script from "./UploadPhotosCard.vue?vue&type=script&lang=js"
export * from "./UploadPhotosCard.vue?vue&type=script&lang=js"

import "./UploadPhotosCard.vue?vue&type=style&index=0&id=10cfca27&lang=css"
script.render = render

export default script